import { render, staticRenderFns } from "./QuestionAB.vue?vue&type=template&id=687112fa&scoped=true&"
import script from "./QuestionAB.vue?vue&type=script&lang=js&"
export * from "./QuestionAB.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAB.vue?vue&type=style&index=0&id=687112fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687112fa",
  null
  
)

export default component.exports